import { MVA_DELSUM_NAVN } from './mvaDelsum';

/**
 * Rows that the backend auto-calculates: their investering (kostnad) is read-only
 * and the row is non-removable. The user only edits Avskrivningstid and Restverdi.
 * These are the Hovedprosjekt row (index 0) and the MVA row (identified by name —
 * it is present only when the leietaker is 0-99 % mva-pliktig).
 */
export const isAutoCalculatedDelsum = (index: number, navn?: string): boolean =>
    index === 0 || navn === MVA_DELSUM_NAVN;
